import { gql } from '@grandvisionhq/graphql';
import { appointmentFragment } from '../../../fragments/appointment.js';

const GET_APPOINTMENT_BY_ID = gql`
  query RescheduleAppointment_GetAppointmentById($id: ID!) {
    appointment(id: $id) {
      ...AppointmentFragment
    }
  }
  ${appointmentFragment}
`;

export { GET_APPOINTMENT_BY_ID };
//# sourceMappingURL=get-appointment-by-id.js.map
